export default "__VITE_ASSET__CdsvAYvv__"